<template>
  <div class="zoom-modal" @click="close">
    <span class="zoom-close">&times;</span>
    <img class="zoom-modal-content" :src="src" alt="Zoom"/>
  </div>
</template>

<script>

export default {

  name: 'zoom-on-image',

  props: {
    src: String
  },

  emits: ['didCloseZoomOnImage'],

  methods: {
    close() {
      this.$emit('didCloseZoomOnImage')
    }
  }
}
</script>

<style scoped>


/* The Modal (background) */
.zoom-modal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-modal-content {
  min-width: 300px;
  max-width: 80%;
  max-height: 100%;
}

@media only screen and (max-width: 700px) {
  .zoom-modal-content {
    width: 100%;
  }
}

/* Add Animation */
.zoom-modal-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.4s;
  animation-name: zoom;
  animation-duration: 0.4s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0)
  }
  to {
    -webkit-transform: scale(1)
  }
}

@keyframes zoom {
  from {
    transform: scale(0)
  }
  to {
    transform: scale(1)
  }
}

/* The Close Button */
.zoom-close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.zoom-close:hover,
.zoom-close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/b122/ZoomOnImage.vue